import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ADMIN_TOKEN_KEY } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      const res = await api.login(password);
      localStorage.setItem(ADMIN_TOKEN_KEY, res.token);
      toast.success("Signed in as Admin");
      navigate("/admin");
    } catch (err) {
      toast.error("Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-24">
      <div className="border border-[var(--ink)] p-8 bg-white">
        <div className="font-label text-xs text-[var(--brand-blue)] mb-4">Restricted</div>
        <h1 className="font-display text-4xl mb-2">Admin Login.</h1>
        <p className="text-sm text-[var(--ink-soft)] mb-8">Enter the admin password to manage hotels.</p>

        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="font-label text-[10px] text-[var(--ink-soft)] block mb-2">Password</label>
            <div className="flex items-center border-b-2 border-[var(--ink)]">
              <Lock className="w-4 h-4 text-[var(--ink-soft)] mr-2" />
              <input
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="flex-1 bg-transparent border-0 outline-none py-3 text-base"
                autoFocus
              />
            </div>
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[var(--ink)] text-white px-6 py-4 font-display text-sm hover:bg-[var(--brand-blue)] transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
